import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { INDICATOR_DIMENSIONS, CIRCLE_DIMENSIONS, CIRCLE_POSITIONS } from './Toggle.constants.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var ToggleContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  opacity: ", ";\n\n  // apply hover styles to the Indicator if NOT disabled\n  ", "\n"])), function (_ref) {
  var $disabled = _ref.$disabled,
    theme = _ref.theme;
  return $disabled && theme.opacity.disabled;
}, function (_ref2) {
  var theme = _ref2.theme,
    $checked = _ref2.$checked,
    $disabled = _ref2.$disabled;
  return !$disabled && "\n    &:hover > span {\n      background-color: ".concat($checked ? theme.colours["interface"].strong : theme.colours.layering[0].strong, ";\n    }\n  ");
});
var Checkbox = styled.input.attrs({
  type: 'checkbox'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  appearance: none;\n"])));
var Indicator = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  cursor: ", ";\n  display: flex;\n  align-items: center;\n  ", "\n  border-radius: ", ";\n  background-color: ", ";\n  margin-right: ", ";\n\n  &:focus-visible {\n    box-shadow: ", ";\n    outline: none;\n  }\n"])), function (_ref3) {
  var $disabled = _ref3.$disabled;
  return $disabled ? 'default' : 'pointer';
}, function (_ref4) {
  var $size = _ref4.$size;
  return INDICATOR_DIMENSIONS[$size];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius.primary;
}, function (_ref6) {
  var theme = _ref6.theme,
    $checked = _ref6.$checked;
  return $checked ? theme.colours["interface"].main : theme.colours.layering[0].main;
}, function (_ref7) {
  var theme = _ref7.theme,
    $hasLabel = _ref7.$hasLabel;
  return $hasLabel ? theme.sizing.small : '0';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.effects.focus;
});
var Circle = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  ", "\n  display: flex;\n  position: relative;\n  ", "\n  transition: 0.1s;\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colours.graphics.inverse.main;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.borderRadius.ellipse;
}, function (_ref11) {
  var $size = _ref11.$size;
  return CIRCLE_DIMENSIONS[$size];
}, function (_ref12) {
  var $size = _ref12.$size,
    $checked = _ref12.$checked,
    theme = _ref12.theme;
  return CIRCLE_POSITIONS[$size]($checked, theme);
});

export { Checkbox, Circle, Indicator, ToggleContainer };
//# sourceMappingURL=Toggle.styles.js.map
